import { ChangeDetectionStrategy, Component, Directive, EventEmitter, Input, Output } from '@angular/core';
import { BbTemplate } from '@backbase/foundation-ang/core';
import { ChallengeError } from '@backbase/identity-core-ang';

@Component({
  selector: 'bb-transaction-signing-error',
  templateUrl: 'error.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TransactionSigningErrorComponent {
  /* tslint:disable-next-line */
  @Output() close = new EventEmitter<Error>();
  @Input() error: ChallengeError | undefined;
  readonly hostRef = this;

  onClose() {
    this.close.emit(new Error(this.error && (this.error.errorDescription || this.error.errorCode)));
  }
}

@Directive({
  selector: '[bbTransactionSigningErrorCustomizable]',
})
export class TransactionSigningErrorCustomizableDirective extends BbTemplate<
  TransactionSigningErrorComponent,
  undefined
> {}
